import { ADMIN_SUBSCRIPTIONS, ADMIN_SUBSCRIPTIONS_SUMMARY } from '@/store/actions/admin/subscriptions.actions';

const initialState = {
  subscriptions: [],
  subscriptions_meta: {},
  summary: {}
};

export default function subscriptions(state = initialState, action) {
  switch (action.type) {
    case ADMIN_SUBSCRIPTIONS:
      return {
        ...state,
        subscriptions: action.payload.data,
        subscriptions_meta: action.payload.meta
      };
    case ADMIN_SUBSCRIPTIONS_SUMMARY:
      return {
        ...state,
        summary: action.payload.data
      };
    default:
      return state;
  }
}
